import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getShipmentsStates,
    getShipmentsMonths,
    getChargesMonths,
    getChargesRefundsMonths,
}


function getShipmentsStates(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60
        Superagent
            .get(`${HOST_API}/graphics/shipments/states`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsMonths(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/shipments/months`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getChargesMonths(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/charges/months`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getChargesRefundsMonths(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/charges/refunds/months`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}
